import './img/bathroom-360.jpg';

import Component from '../../components/component/component';

import 'pannellum';
import './pannellum.scss';

// eslint-disable-next-line
declare let pannellum: any;

interface IPannellumSettings {
    activeClass?: string;
    figureClass?: string;
    grabClass?: string;
    loadClass?: string;
    clickClass?: string;
}

export default class Pannellum extends Component {
    static initSelector: string = '.js-pannellum';

    settings: IPannellumSettings;
    // eslint-disable-next-line
    pannellum: any;
    imageSource: string;
    trigger: JQuery;
    figure: JQuery;
    autoplay: boolean;
    dragElement: JQuery;
    button: JQuery;

    constructor(target: HTMLElement) {
        super(target);

        this.settings = {
            activeClass: 'is-active',
            clickClass: 'was-clicked',
            figureClass: 'pannellum__figure',
            grabClass: 'pnlm-ui',
            loadClass: 'is-loading',
        };

        this.figure = this.element.find('.pannellum__figure');
        this.imageSource = this.figure.data('image');
        this.trigger = this.element.find('.pannellum__trigger');
        this.autoplay = this.figure.data('autoplay');
        this.button = this.element.find('.pannellum__button');

        this.init();
    }

    init(): void {
        if (this.autoplay) {
            this.render();
            this.button.on('click', (event: JQuery.TriggeredEvent) => {
                event.preventDefault();
                this.element.addClass(this.settings.clickClass);
            });
        } else {
            this.trigger.on('mousedown click', this.clickHandler.bind(this));
        }
    }

    clickHandler(event?: JQuery.TriggeredEvent): void {
        if (event) {
            event.preventDefault();
        }

        this.render(event);
        this.element.addClass(this.settings.clickClass);
    }

    render(event?: JQuery.TriggeredEvent): void {
        if (event) {
            event.preventDefault();
        }

        this.element.addClass(this.settings.loadClass);

        this.pannellum = pannellum.viewer(this.figure.get(0), {
            autoLoad: true,
            autoRotate: this.autoplay ? -2 : 0,
            autoRotateInactivityDelay: 200,
            mouseZoom: false,
            panorama: this.imageSource,
            showControls: false,
            type: 'equirectangular',
        });

        this.pannellum.on('load', this.loadListener.bind(this));
    }

    loadListener(): void {
        this.element.removeClass(this.settings.loadClass);
        this.element.addClass(this.settings.activeClass);
        this.dragElement = this.element.find('.pnlm-dragfix');
        this.dragElement.on('mousedown touchstart', () => {
            this.pannellum.stopAutoRotate();
        });
    }
}

$(document).on('mousedown touchstart', '.pnlm-ui', (event: JQueryEventObject) => {
    const pannellumElement: JQuery = $(event.target).parents('.pannellum');

    pannellumElement.addClass('is-drag');

    if (!pannellumElement.hasClass('was-clicked')) {
        pannellumElement.addClass('was-clicked');
    }
});
